{
  "feedback-emotion-page": {
    "text": {
      "title": "Vaše zpětná vazba",
      "subtitle": "Pomozte nám prosím zlepšit naše služby",
      "dissatisfied": "Nespokojenost",
      "on": "k",
      "neutral": "Neutrální",
      "satisfaction-question": "Jste spokojeni s našimi službami?",
      "satisfied": "Spokojený",
      "thanks": "Děkujeme vám za návštěvu",
      "tip": "Tip: Kliknutím na ikonu obličeje vyjádříte, jak jste s našimi službami spokojeni"
    }
  }
}
